import Requests from "@/services/Requests";

const state = {
  extraProductRules: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allExtraProductRules: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  extraProductRuleById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of extraProductRules based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter extraProductRules by. Defaults to 0.
   * @return {Array} An array of extraProductRules filtered by the given page number. If page is 0, returns all extraProductRules.
   */
  getExtraProductRules:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.extraProductRules.data
        : state.extraProductRules.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllExtraProductRules: (state) => state.allExtraProductRules.data,
  getExtraProductRuleStatus: (state) => state.extraProductRules.status,
  getExtraProductRuleCount: (state) => state.extraProductRules.count,
  getExtraProductRulePages: (state) =>
    Math.ceil(state.extraProductRules.count / 10),
  getExtraProductRulePage: (state) => state.extraProductRules.page,
  getExtraProductRulesLoading: (state) =>
    state.extraProductRules.status === "loading",
  getExtraProductRuleById: (state) => (id) =>
    state.extraProductRuleById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the extraProductRule in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the extraProductRule.
   */
  SET_EXTRA_PRODUCT_RULE_STATUS(state, payload) {
    console.log(state.extraProductRules, "status: ", payload);
    state.extraProductRules.status = payload;
  },
  /**
   * Sets the extraProductRules and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of extraProductRules.
   * @param {number} payload.count - The total count of extraProductRules.
   */
  SET_EXTRA_PRODUCT_RULES(state, payload) {
    if (payload.force) state.extraProductRules.data = [...payload.items];
    else
      state.extraProductRules.data = [
        ...state.extraProductRules.data,
        ...payload.items,
      ];
    state.extraProductRules.count = payload.count;
  },
  /**
   * Sets the extraProductRules and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of extraProductRules.
   * @param {number} payload.count - The total count of extraProductRules.
   */
  SET_ALL_EXTRA_PRODUCT_RULES(state, payload) {
    console.log("SET_ALL_EXTRA_PRODUCT_RULES", payload);
    state.allExtraProductRules.data = payload.items;
    state.allExtraProductRules.count = payload.count;
  },
  /**
   * Updates the status of the update extraProductRule in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the extraProductRule.
   */
  SET_UPDATE_EXTRA_PRODUCT_RULE_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an extraProductRule object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated extraProductRule object.
   * @return {void}
   */
  SET_UPDATE_EXTRA_PRODUCT_RULE(state, payload) {
    const index = state.extraProductRules.data.findIndex(
      (d) => d.id === payload.id
    );
    const extraProductRule = state.extraProductRules.data[index];
    state.extraProductRules.data[index] = { ...extraProductRule, ...payload };
  },
  SET_CREATE_EXTRA_PRODUCT_RULE_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new extraProductRule to the list of extraProductRules in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The extraProductRule object to be added.
   * @return {void}
   */
  SET_CREATE_EXTRA_PRODUCT_RULE(state, payload) {
    state.extraProductRules.data.push(payload);
  },
  /**
   * Updates the status of the delete extraProductRule in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the extraProductRule.
   */
  SET_DELETE_EXTRA_PRODUCT_RULE_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an extraProductRule from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the extraProductRule ID to be deleted.
   * @param {number} payload.id - The ID of the extraProductRule to be deleted.
   * @return {void}
   */
  SET_DELETE_EXTRA_PRODUCT_RULE(state, payload) {
    state.extraProductRules.data = state.extraProductRules.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_EXTRA_PRODUCT_RULE_BY_ID_STATUS(state, payload) {
    state.extraProductRuleById.status = payload;
  },
  SET_EXTRA_PRODUCT_RULE_BY_ID(state, payload) {
    state.extraProductRuleById.data.push(payload);
  },
};

const actions = {
  /**
   * Retrieves a list of extraProductRules based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.search - The search key.
   * @param {string} payload.query.regionId - The region ID.
   * @param {string} payload.query.companyId - The company ID.
   * @param {number} payload.query.page - The page number.
   * @return {Promise<void>}
   */
  async getExtraProductRules({ state, commit }, payload) {
    // if query param is not in payload or if there is already data with same page number, don't fetch again
    const searchKey = payload.query?.search || "";
    const search = payload.query?.search || "";
    if (
      state.extraProductRules.data.filter(
        (extraProductRule) =>
          extraProductRule.page === payload.query.page &&
          (extraProductRule.search || "") === searchKey
      ).length > 0 &&
      !payload.force
    )
      return;
    const status = state.extraProductRules.status;
    commit("SET_EXTRA_PRODUCT_RULE_STATUS", "loading");
    const response = await Requests.ExtraProductRule.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_EXTRA_PRODUCT_RULES", {
        items: response.data.items.map((item) => ({
          ...item,
          page: payload.query.page,
          search,
        })),
        count: response.data.count,
        force: payload.force || false,
      });
      if (status === "unitiliazed")
        commit("SET_ALL_EXTRA_PRODUCT_RULES", {
          items: response.data.items.map((item) => ({
            ...item,
            page: payload.query.page,
            search,
          })),
          count: response.data.count,
        });
    }
    commit("SET_EXTRA_PRODUCT_RULE_STATUS", "success");
    return response.message;
  },
  /**
   * Creates an extraProductRule by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the extraProductRule data.
   * @param {string} payload.fullName - The full name of the extraProductRule.
   * @param {string} payload.phoneNumber - The phone number of the extraProductRule.
   * @param {string} payload.email - The email of the extraProductRule.
   * @param {string} payload.regionId - The ID of the region the extraProductRule belongs to.
   * @param {File} payload.image - The image of the extraProductRule.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createExtraProductRule({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.ExtraProductRule.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_EXTRA_PRODUCT_RULE", {
          id: response.data,
          fullName: payload.fullName,
          phoneNumber: payload.phoneNumber,
          email: payload.email,
          regionId: payload.regionId,
          image: payload.image,
          workStartTime: payload.workStartTime,
          workEndTime: payload.workEndTime,
          page: 1,
        });
      else state.createStatus = "error";
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an extraProductRule by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the extraProductRule data to update.
   * @param {string} payload.fullName - The full name of the extraProductRule.
   * @param {string} payload.phoneNumber - The phone number of the extraProductRule.
   * @param {string} payload.email - The email of the extraProductRule.
   * @param {string} payload.regionId - The ID of the region the extraProductRule belongs to.
   * @param {File} payload.image - The image of the extraProductRule.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @param {boolean} payload.isActive - Whether the extraProductRule is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updateExtraProductRule({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.ExtraProductRule.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_EXTRA_PRODUCT_RULE", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
    } catch {
      state.updateStatus = "error";
    }
  },
  /**
   * Removes an extraProductRule from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the extraProductRule data.
   * @param {number} payload.id - The ID of the extraProductRule to be removed.
   * @returns {Promise<void>} A promise that resolves when the extraProductRule is successfully removed.
   */
  removeExtraProductRule({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.ExtraProductRule.Delete({ id })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
      })
      .catch(() => {
        state.deleteStatus = "error";
      });
  },
  /**
   * Retrieves an extraProductRule by their ID and updates the extraProductRule by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the extraProductRule to retrieve.
   * @return {Promise} A promise that resolves when the extraProductRule is successfully retrieved and the status is updated.
   */
  getExtraProductRuleById({ commit, state }, { id }) {
    // check if extraProductRule already exists in the state;
    if (
      state.extraProductRuleById.data.find(
        (extraProductRule) => extraProductRule.id === id
      )
    )
      return;
    commit("SET_EXTRA_PRODUCT_RULE_BY_ID_STATUS", "loading");
    return Requests.ExtraProductRule.GetById({ params: { id } })
      .then((response) => {
        commit("SET_EXTRA_PRODUCT_RULE_BY_ID", response.data);
        commit("SET_EXTRA_PRODUCT_RULE_BY_ID_STATUS", "success");
      })
      .catch(() => {
        commit("SET_EXTRA_PRODUCT_RULE_BY_ID_STATUS", "error");
      });
  },
};

export default { state, getters, mutations, actions };
